export const INNO_BRAND_PROPERTY = "merk_property";
export const MAILCHIMP_URL_PROPERTY = "Mailchimp URL";
